/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 電解槽情報（出力情報）
 * @export
 * @interface ElectrolyzerOutput
 */
export interface ElectrolyzerOutput {
    /**
     * No.
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    no?: number;
    /**
     * 電解槽名
     * @type {string}
     * @memberof ElectrolyzerOutput
     */
    electrolyzer?: string;
    /**
     * 稼働/停止
     * @type {string}
     * @memberof ElectrolyzerOutput
     */
    operate?: string;
    /**
     * 電流
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    optimizedCurrent?: number;
    /**
     * 電圧
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    voltage?: number;
    /**
     * 苛性温度
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    temp?: number;
    /**
     * PC
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    pc?: number;
    /**
     * 苛性生産量
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    naohProduction?: number;
    /**
     * 苛性中食塩濃度
     * @type {number}
     * @memberof ElectrolyzerOutput
     */
    naclInNaoh50?: number;
}

/**
 * Check if a given object implements the ElectrolyzerOutput interface.
 */
export function instanceOfElectrolyzerOutput(value: object): value is ElectrolyzerOutput {
    return true;
}

export function ElectrolyzerOutputFromJSON(json: any): ElectrolyzerOutput {
    return ElectrolyzerOutputFromJSONTyped(json, false);
}

export function ElectrolyzerOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ElectrolyzerOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'no': json['no'] == null ? undefined : json['no'],
        'electrolyzer': json['electrolyzer'] == null ? undefined : json['electrolyzer'],
        'operate': json['operate'] == null ? undefined : json['operate'],
        'optimizedCurrent': json['optimizedCurrent'] == null ? undefined : json['optimizedCurrent'],
        'voltage': json['voltage'] == null ? undefined : json['voltage'],
        'temp': json['temp'] == null ? undefined : json['temp'],
        'pc': json['pc'] == null ? undefined : json['pc'],
        'naohProduction': json['naohProduction'] == null ? undefined : json['naohProduction'],
        'naclInNaoh50': json['naclInNaoh50'] == null ? undefined : json['naclInNaoh50'],
    };
}

export function ElectrolyzerOutputToJSON(value?: ElectrolyzerOutput | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'no': value['no'],
        'electrolyzer': value['electrolyzer'],
        'operate': value['operate'],
        'optimizedCurrent': value['optimizedCurrent'],
        'voltage': value['voltage'],
        'temp': value['temp'],
        'pc': value['pc'],
        'naohProduction': value['naohProduction'],
        'naclInNaoh50': value['naclInNaoh50'],
    };
}

